import { styled } from '@mui/material/styles';
export var DateTimeViewWrapper = styled('div')({
  display: 'flex',
  margin: '0 auto'
});